type GetValuesFunc =
  (keys: {
    [k: string]: {
      [k: string]: boolean;
    };
  }) => { [k: string]: string; };

let styles: CSSStyleDeclaration | null = document.body.style;
let getValues: GetValuesFunc | null = function(keys) {
  const result = {};
  for(const key in keys) {
    const content = keys[key];
    for(const property in content) {
      if(content[property]) {
        result[key] = property;
        break;
      }
    }
  }
  return result;
};

const cssValues = getValues({
  transform: {
    transform: 'transform' in styles,
    webkitTransform: 'webkitTransform' in styles
  },
  transitionDuration: {
    transitionDuration: 'transitionDuration' in styles,
    webkitTransitionDuration: 'webkitTransitionDuration' in styles
  },
  transitionTimingFunction: {
    transitionTimingFunction: 'transitionTimingFunction' in styles,
    webkitTransitionTimingFunction: 'webkitTransitionTimingFunction' in styles
  }
});

styles = null;
getValues = null;

const Compatibility = {
  css: cssValues
};

export default Compatibility
